import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const ExitSurveyAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "exit-survey" */ './exit-survey'),
  componentName: 'ExitSurvey',
});
